import { OnlineStorage, IStorageUser } from "@tblabs/storage";
import { Line, Table, TextInput, MultilineInput, Snack } from "@tblabs/truffle";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Page } from "./Page";
import { UserRef } from "../Models/UserRef";


export class AddUserPage extends Page
{
    constructor(private _storage: OnlineStorage)
    {
        super("User creation");

        this.Content(async () =>
        {
            const userRef = new UserRef();

            this.body.Append(
                new Panel("New User", [
                    new Line(),
                    new PrimaryButton("Save").OnClick(() => this.CreateUser(userRef.AsRaw)),
                ]),
                new Panel("Fileds", [
                    new Table([], [
                        ["Name", new TextInput(userRef.Name)],
                        ["Email", new TextInput(userRef.Email)],
                        ["Role", new TextInput(userRef.Role)],
                        ["Icon", new TextInput(userRef.Icon)],
                        ["Login", new TextInput(userRef.Login)],
                        ["Password", new TextInput(userRef.Password)],
                        ["Privileges", new MultilineInput(userRef.Privileges).Rows(12)],
                        ["Tags", new TextInput(userRef.Tags)],
                    ]).Class("uk-table")
                ])
            );
        });
    }

    private async CreateUser(user: IStorageUser): Promise<void>
    {
        try
        {
            await this._storage.AddUser(user);

            new Snack("✅ User created");

            window.location.hash = `admin/user/${user.Id}`;
        }
        catch (ex: any)
        {
            new Snack("❌ Failed to create user", ex.message);
        }
    }
}
